import { FETCHED_PAGES, LOADING_PAGES } from 'common/types/pagesList';

const initialState = {
  pages: [],
  loading: false,
};

const pagesReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCHED_PAGES:
      return {
        ...state,
        pages: action.pages,
        loading: false,
      };

    case LOADING_PAGES:
      return {
        ...state,
        loading: action.payload,
      };
    default:
      return state;
  }
};

export default pagesReducer;
